import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Icon,
  Link,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { Button } from "@chakra-ui/react";
import React, { useState, useEffect } from 'react';
import StartTourButton from 'components/ProductTour/StartTourButton';
import AdminNavbarLinks from 'components/navbar/NavbarLinksAdmin';
import Cookies from 'js-cookie';
import { IoMenuOutline } from 'react-icons/io5';
import httpInjectorService from 'services/http-injector.service';
import { useDispatch, useSelector } from 'react-redux';
import {
  Compass,
} from "lucide-react";
import { setUsername } from 'store/actions';
import { useNavigate } from "react-router-dom";

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);
  const [showTour, setShowTour] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const username = useSelector((state) => state.Authentication.username)
  const dispatch = useDispatch()
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener('scroll', changeNavbar);

    return () => {
      window.removeEventListener('scroll', changeNavbar);
    };
  }, []); // Added dependency array here

  const getUserDetails = async () => {
    try {
      const response = await httpInjectorService.getUsersDetails()
      if (response.status === 'success') {
        dispatch(setUsername(response.data.username))
      } else {
        dispatch(setUsername(""))
      }
    } catch (err) {
      dispatch(setUsername(""))
    }
  }

  useEffect(() => {
    getUserDetails()
  }, [])

  const { secondary, message, brandText } = props;
  const { setIsCollapsed, isCollapsed } = props;

  // Set the navbar background color to blue
  let mainText = useColorModeValue('navy.700', 'white');
  let secondaryText = useColorModeValue('gray.700', 'white');
  let navbarPosition = 'fixed';
  let navbarFilter = 'none';
  let navbarBackdrop = 'blur(20px)';
  let navbarShadow = 'none';
  let navbarBg = '#884b9e'; // Changed to blue
  let navbarBorder = 'transparent';
  let secondaryMargin = '0px';
  let paddingX = '15px';
  let gap = '0px';
  const changeNavbar = () => {
    if (window.scrollY > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };


  //  const startTourAgain = () => {
  //   sessionStorage.setItem("show-tour-welcome", "true");
  //   sessionStorage.removeItem("pulse-auto-tour");
  //   navigate("/admin/default");
  // };

  const startTourAgain = () => {
  
    window.dispatchEvent(new Event("restart-tour"));
  };


  return (
    <Box
      position={navbarPosition}
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      backgroundPosition="center"
      backgroundSize="cover"
      // borderRadius="16px"
      borderWidth="1.5px"
      borderStyle="solid"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration="0.25s, 0.25s, 0.25s, 0s"
      transition-property="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear, linear, linear, linear"
      alignItems={{ xl: 'center' }}
      display={secondary ? 'block' : 'flex'}
      minH="50px"
      justifyContent={{ xl: 'center' }}
      lineHeight="25.6px"
      mx="0"
      mt={secondaryMargin}
      pb="4px"
      px={{
        sm: paddingX,
        md: '10px',
      }}
      ps={{
        xl: '12px',
      }}
      pt="4px"
      top="0"
      w={{
        base: 'calc(100vw - 6%)',
        md: 'calc(100vw - 8%)',
        lg: 'calc(100vw - 6%)',
        // xl: `calc(100vw - ${isCollapsed ? '60px' : '250px'})`,
        // '2xl': `calc(100vw - ${isCollapsed ? '60px' : '250px'})`,
        xl: `calc(100vw - '300px')`,
        '2xl': `calc(100vw -'300px')`,
      }}
      // Added inline CSS for hiding the scrollbar
      sx={{
        '::-webkit-scrollbar': {
          display: 'none',
        },
        '-ms-overflow-style': 'none' /* Internet Explorer 10+ */,
        'scrollbar-width': 'none' /* Firefox */,
      }}
      // Using media queries to apply left="300" on desktop only
      css={{
        '@media (min-width: 900px)': {
          // left:'80px',
          width: '-webkit-fill-available'
        },
      }}
    >
      <Flex
        w="100%"
        flexDirection={{
          sm: 'column',
          md: 'row',
        }}
        alignItems={{ xl: 'center' }}
        mb={gap}
      >
        <Box display={{ base: 'none', md: 'flex' }} alignItems="center">
          {/* <Icon
            as={IoMenuOutline}
            my="auto"
            color="white"
            w="30px"
            h="30px"
            me="10px"
            _hover={{ cursor: 'pointer' }}
            onClick={() => setIsCollapsed(!isCollapsed)}
          /> */}
          <h4 style={{ color: 'white', margin: '0 auto', marginLeft: '250px' }}>
            Hi {username}&nbsp;!
          </h4>
        </Box>
        <Box ms="auto" w={{ sm: '100%', md: 'unset', lg: '500px' }}>
          {/* <Flex
  bg="white"
  p={4}
  borderRadius="20px"
  boxShadow="0 10px 30px rgba(0,0,0,0.15)"
  cursor="pointer"
  align="center"
  gap={3}
  position="relative"
  zIndex={9999}
  onClick={() => {
    console.log("clicked");
    startTourAgain();
  }}
>
  <Compass size={22} color="#38A169" />
  <Text fontWeight="600">Take a Tour</Text>
</Flex> */}
          {/* <Button
  leftIcon={<Compass size={18} />}
  variant="outline"
  border="2px solid"
  borderColor="green.400"
  color="green.600"
  bg="white"
  borderRadius="full"
  px={5}
  py={6}
  fontWeight="600"
  _hover={{
    bg: "green.50",
    borderColor: "green.500",
  }}
  _active={{
    bg: "green.100",
  }}
  onClick={startTourAgain}
>
  Take a Tour
</Button> */}
          
          <AdminNavbarLinks
            onOpen={props.onOpen}
            logoText={props.logoText}
            secondary={props.secondary}
            fixed={props.fixed}
            scrolled={scrolled}
          />
        </Box>
        {showTour && (
          <Box
            position="fixed"
            bottom="30px"
            right="10px"
            zIndex={10000}
          >
            <StartTourButton
              defaultOpen={true}
              onClose={() => setShowTour(false)}
            />
          </Box>
        )}
      </Flex>
      {secondary ? <Text color="white">{message}</Text> : null}
    </Box>
  );
}